import CachedView from 'common/builder/components/chart/FlowChart/nodes/shared/CachedView/CachedView'

export const ExposeCoordinatesView = CachedView
